var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TEXT_VIEW, TEXT_SIZE, TEXT_WEIGHT } from "../Text";
import { INDENT } from "../View";
import { StructureText } from './StructureText';
import { createUIElement } from "../helpers";
export var TitleH1 = createUIElement('TitleH1', function (_a, ref) {
    var className = _a.className, children = _a.children, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(StructureText, __assign({}, rest, { testId: rest['data-selector-id'] || 'title-h1', className: "vm-TitleH1 " + className, asTag: 'h1', view: TEXT_VIEW.primary, weight: TEXT_WEIGHT.normal, size: TEXT_SIZE.xl, trailer: INDENT.m, "data-typo": true, "data-h1": true, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
//# sourceMappingURL=TitleH1.js.map